import { IRootState } from 'CorePackage/MainModule/interfaces/IRootState';

export const getPmListFilterFilters = (state: IRootState) => state.pmListFilter.filters;
export const getPmListFilterCurrentFilter = (state: IRootState) => state.pmListFilter.current;
export const getPmListFilterIsFilterOn = (state: IRootState) => state.pmListFilter.isFilterOn;
export const getPmListFilterCurrentId = (state: IRootState) => state.pmListFilter.currentId;
export const getPmListCurrentControlOrganizations = (state: IRootState) =>
  state.pmListFilter.currentControlOrganizations;
export const getPmListCurrentSupervisionTypes = (state: IRootState) => state.pmListFilter.currentSupervisionTypes;
